export default __webpack_public_path__ + "static/RaniyahCopeland_mobile-09ae9376f8dc8b920084463aaaeee6f8.jpg";